var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkeleton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 17)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillRule: "nonzero",
    points: "44.579 15.845 0 15.878 0 13.848 44.579 13.815"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m43.088 1.456 3.94-.276 2.24 1.468-1.256 3.175-.06.507c-.172 1.453-1.491 2.493-2.947 2.322-.217-.025-.43-.078-.634-.155l-.2-.086-2.308-.993-.723-2.148 1.948-3.814Z",
    transform: "rotate(10 45.204 4.925)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D09D",
    d: "m45.47 6.316 3.648-3.416-1.256 3.175-.06.507c-.172 1.453-1.492 2.493-2.947 2.322-.217-.025-.43-.078-.634-.155l-.2-.086 1.448-2.347Z",
    transform: "rotate(10 46.57 5.912)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "M43.177 2.09c.245-.559.688-1.008 1.245-1.26l.09-.04c.618-.28 1.313-.337 1.968-.164l.503.134c.977.258 1.827.862 2.392 1.699l.243.36-.957 2.675-4.992-2.158c-.44-.19-.662-.674-.536-1.122l.044-.123Z",
    transform: "rotate(10 46.358 3.011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m49.425 2.991.177.398-1.407 2.468-1.806-1.19 2.222-2.88c.337.348.614.755.814 1.204Z",
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "m45.435 6.346.765-1.715 2.015.812c-.113.631-.264 1.26-.595 1.874l-2.185-.971Z",
    transform: "rotate(10 46.825 5.974)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#282828",
    points: "42.263 3.243 42.627 2.427 46.612 4.199 46.249 5.015",
    transform: "rotate(10 44.438 3.72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m39.512 4.659.47 3.08 2.35 1.571c1.16.767 1.907 1.243 2.239 1.428-.253.933-.982 1.442-2.323 1.442l-11.33.02 1.443-2.508 5.195-.82-.254-1.607-3.898.616.027-.046-7.923 1.282-1.468 3.095-3.835.007-15.68-2.373-1.789 2.357-1.8-.016 1.512-4.935 20.466-.42 16.598-2.173Zm-9.218 5.36-1.254 2.18-3.168.002.752-1.602 3.67-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m31.951 10.404 10.15.253 2.47.078c-.251.935-.98 1.445-2.323 1.445-3.759 0-7.539.013-11.34.039l1.043-1.815Zm-3.316-.082 1.464.036-1.059 1.84-1.576 0 1.171-1.876Z",
    opacity: 0.296
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "26.613 10.586 30.313 9.987 29.04 12.198 25.848 12.201"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeleton);
export default __webpack_public_path__ + "static/media/skeleton.a964891d63ebd7df0eae715d94a2b80f.svg";
export { ForwardRef as ReactComponent };